.search-header {
    border-bottom: 1px solid var(--off-white-dk);
}
